import reducer from "./reducer";
export { default as TypesOfBenefits } from "./components/index";
export { default as typesOfBenefitsReducerName } from "./constants";
export default reducer;
